import React, { useEffect, useState } from 'react';
import { Button, FormGroup, Input, Label, Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import '../../Pages/Css/correccionFechas.css';

const ModalTrackingTiempoReal = ({ isOpen, onOpenTracking }) => {
    const [contract, setContract] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setContract('');
            setLoading(false);
        }
    }, [isOpen]);

    const loadContract = async (event) => {
        event.preventDefault();
        const normalizedContract = contract.trim().toUpperCase();

        if (!normalizedContract) {
            return Swal.fire('Informacion', 'Ingrese el contrato que desea consultar.', 'info');
        }

        setLoading(true);
        try {
            await onOpenTracking?.(normalizedContract);
        } catch (error) {
            Swal.fire(
                'Error',
                error.response?.data?.message || error.response?.data?.mensaje || error.message || 'Error consultando el contrato.',
                'error'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className="date-correction-search" onSubmit={loadContract}>
            <FormGroup>
                <Label for="tracking-tiempo-real-contract">Contrato</Label>
                <Input
                    id="tracking-tiempo-real-contract"
                    value={contract}
                    onChange={(event) => setContract(event.target.value.toUpperCase())}
                    placeholder="SERV-123456789"
                    autoComplete="off"
                    autoFocus
                />
            </FormGroup>
            <div className="date-correction-actions" style={{ justifyContent: 'center' }}>
                <Button type="submit" className="platform-primary-button" disabled={loading}>
                    {loading ? <><Spinner size="sm" /> Cargando...</> : 'Abrir tracking'}
                </Button>
            </div>
        </form>
    );
};

export default ModalTrackingTiempoReal;
